export default "__VITE_ASSET__NN$NFrAo__"